import { createSlice } from "@reduxjs/toolkit";

export const weekOfYearSlice = createSlice({
    name: 'weekofyear',
    initialState: {
        value: undefined
    },
    reducers: {
        // setStartWeek: (state, action) => {
        //     state.start = action.payload;
        // },
        // setEndWeek: (state, action) => {
        //     state.end = action.payload;
        // },
        setWeekOfYear: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setWeekOfYear } = weekOfYearSlice.actions;

export const getWeekOfYear = (state) => state.weekofyear.value;

export default weekOfYearSlice.reducer;